export default __webpack_public_path__ + "static/media/instacap.9d958fb6.png";